import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import DateFilterMenu from "./DateFilterMenu";

export const filterTextInput = (value: string, filter: string): boolean => {
  if (!filter) return true;
  if (!value) return false;
  return value.toLowerCase().includes(filter.toLowerCase());
};

export const textFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <InputText
      type="text"
      value={options.value || ""}
      onChange={(e) => options.filterCallback(e.target.value)}
      placeholder="Поиск..."
      className="p-column-filter"
    />
  );
};

export const filterNumberInput = (value: number, filter: number): boolean => {
  if (!filter || filter === null || filter === undefined) return true;
  if (!value || value === null || value === undefined) return false;
  return value === filter;
};

export const filterIncludeNumberInput = (
  value: number,
  filter: number
): boolean => {
  if (!filter || filter === null || filter === undefined) return true;
  if (!value || value === null || value === undefined) return false;
  return value.toString().includes(filter.toString());
};

export const numberFilterMatchModeOptions = [
  { label: "Равно", value: "equals" },
  { label: "Не равно", value: "notEquals" },
  { label: "Больше", value: "gt" },
  { label: "Меньше", value: "lt" },
  { label: "Больше или равно", value: "gte" },
  { label: "Меньше или равно", value: "lte" },
];

export const numberFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <InputNumber
      value={options.value ?? null}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Поиск..."
      className="p-column-filter"
    />
  );
};

export const dateFilterFunction = (
  value: string | Date,
  filter: any
): boolean => {
  if (!filter || !filter.value || filter === undefined) return true;
  const rowDate = new Date(value).setHours(0, 0, 0, 0);
  const filterDate = new Date(filter.value).setHours(0, 0, 0, 0);
  switch (filter.operator) {
    case "equals":
      return rowDate === filterDate;
    case "after":
      return rowDate > filterDate;
    case "before":
      return rowDate < filterDate;
    default:
      return true;
  }
};

export const dateFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <DateFilterMenu
      value={options.value}
      filterCallback={options.filterCallback}
    />
  );
};
